import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import React__default, { useMemo, useState, useRef, useCallback, useEffect } from 'react';
import { styled } from 'styled-components';
import { shallow as shallow$1 } from '../../../../node_modules/zustand/esm/shallow.js';
import { StoredFileContent } from './StoredFileContent.js';
import { useResourceDataContextSafe } from '../context/resourceDataContext.js';
import { useContainedImageSize } from '../../hooks/useContainedImageSize.js';
import { useResourceMoveAndResize, MIN_WIDTH } from '../../hooks/useMoveAndResize.js';
import { useSpaceLiveblocksStore } from '../../../multiplayer/config/spaces.config.js';
import { useMutationResourceTitleRename } from '../../mutations/useMutationResourceTitleRename.js';
import { useMutationNotepadStateUpdate, useOptimisticNotepadStateUpdate } from '../../mutations/useMutationNotepadStateUpdate.js';
import { ResourceTitleEditable } from '../ResourceTitle/ResourceTitleEditable.js';
import { ResourceHighlightText } from '../ExpandedResource/Content/Text/ResourceHighlightText.js';
import { ExpandedFdocElements } from './ExpandedFdocElements.js';
import { ExpandedFdocContentContext } from './ExpandedFdocContentContext.js';
import { useMutationResourcesTagAssign } from '../../../tags/mutations/useMutationResourcesTagAssign.js';
import { useMutationTagCreate } from '../../../tags/mutations/useMutationTagCreate.js';
import { useQueryResourceTags } from '../../../tags/queries/useQueryResourceTags.js';
import { isResourceDetailNotepad, isResourceDetailImage, isResourceDetailBookmark, isResourceDetailAudio, isResourceDetailDefault, isResourceDetailDocument, isResourceDetailHighlight, isResourceIntegrationItem, isResourceDetailEmail } from '../../../resources/utils/resourceDetailGuards.js';
import { useQueryResourceDetail } from '../../../resources/queries/useQueryResourceDetail.js';
import { useQueryUserInfo } from '../../../user/queries/useQueryUserInfo.js';
import { AnalyticsEvents } from '../../../analytics/analytics.types.js';
import { useAnalytics } from '../../../analytics/hooks/useAnalytics.js';
import { SuggestionItemType } from '../../../magic/magic.types.js';
import { isObject, isString } from 'lodash-es';
import TagButton from '../../../tags/components/TagButton.js';
import { mediaSidebarBottom } from '@fabric-app/ui/constants/styled-utils';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { useNewResourceContext } from '../../../resources/components/NewResource/context/ModalNewResourceContext.js';
import MultiplayerEditor from '../../../Tiptap/MultiplayerEditor.js';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';
import { useInputControls } from '@fabric-app/hooks/useInputControls';
import { useModalNewResourceContext } from '../../../resources/components/NewResource/ModalNewResourceContext.js';
import { MagicSuggestionsContextProvider } from '../../../magic/components/MagicSuggestionsContext.js';
import EditTagsModal from '../../../tags/components/EditTagsModal.js';
import { ButtonIcon, Button } from '@fabric-app/ui/components/Button';
import Tooltip from '@fabric-app/ui/components/Tooltip';
import StateSpinner, { useResourceLoadingStateIndicatorProps } from '../../../resources/components/StateSpinner.js';
import { DropdownMenu } from '@fabric-app/ui/components/DropdownMenu/DropdownMenu';
import { Modal } from '@fabric-app/ui/components/Modal/Modal';
import SpaceCursors from '../../../spaces/components/SpaceCursors/SpaceCursors.js';
import { Flex } from '@fabric-app/ui/components/Flex';
import { MagicSuggestions } from '../../../magic/components/MagicSuggestions.js';
import { PageResource } from '../../../expandedResource/components/PageResource.js';
import { DestinationButton } from '../../../resources/components/NewResource/components/DestinationButton.js';
import { useOnWindowClose } from '@fabric-app/hooks/useOnWindowClose';
import { useDebouncedCallback } from '@fabric-app/hooks/useDebouncedCallback';
import { useUnmount } from '@fabric-app/hooks/useUnmount';
import { prettifyForLLM } from '@fabric-app/utils/text';
import { ButtonIconDownload } from '@fabric-app/ui/components/button/ButtonIconDownload';
import useSwipe from '@fabric-app/hooks/useSwipe';
import { useThrottledCallback } from '@fabric-app/hooks/useThrottledCallback';
import usePrevious from '@fabric-app/hooks/usePrevious';
import { PermissionRole } from '@fabric/woody-client';
import { isResourceDetailDocumentPDF } from '../../../resources/documentGuards.js';
import useDocumentPreviewable from '../../hooks/useDocumentPreviewable.js';
import useDocumentUnpreviewable from '../../hooks/useDocumentUnpreviewable.js';
import { useMutationCreateNotepadResource } from '../../../resources/mutations/useMutationCreateNotepadResource.js';
import { v4 } from 'uuid';
import { useMutationMoveResourcesById } from '../../../resources/mutations/useMutationMoveResourcesById.js';
import { useContextShareToken, useContextShareTokenExtraPermissions } from '../../../permission/contexts/AnonShareTokenContext.js';
import { useQueryResourceAssets } from '../../queries/useQueryResourceAssets.js';
import { useDeleteOrLeaveResource } from '../../hooks/useDeleteOrLeaveResource.js';
import { resourceSharingModal } from '../../../permission/components/ModalShare/resourceSharingStore.js';
import { BadgePermissionRole } from '../../../permission/components/BadgePermissionRole.js';
import { LinkExternal } from '@fabric-app/ui/components/Link/LinkExternal';
import { MenuIcon, ExitFullscreenIcon, FullscreenIcon } from '@fabric-app/icons/icons';
import { MemberBarResourcerWithLiveBlocks } from '../../../multiplayer/components/MemberBar/MemberBarResourceWithLiveBlock.js';
import { IconSidebar24HomeIcon, IconNavigational24Search, IconLinkArrow, IconArrow } from '@fabric-app/icons/svg';
import { useExpandedResourceStore, useShowPreviousExpandedResource } from '../../../resources/stores/useExpandedResourceStore.js';
import { useHandleOpenAssetsPanel } from '../AssetsPanel/useOpenAssetsPanel.js';
import { AssetsPanel } from '../AssetsPanel/AssetsPanel.js';
import { NotionFooter } from '../NotionFooter/NotionFooter.js';
import { pick } from '@fabric-app/utils/object/manipulation';
import { DropdownItemResourceRefreshBookmark } from '../DropdownItems/DropdownItemResourceRefreshBookmark.js';
import { DropdownItemResourceUserPinHome } from '../DropdownItems/DropdownItemResourceUserPinHome.js';
import { resourceMoveModal } from '../../../resources/components/ModalMoveResources/moveResourcesStore.js';
import { NotepadUpdateFailsafeService } from '../../../Tiptap/storage/NotepadUpdateFailsafeService.js';
import * as Y from 'yjs';
import { useWindowEvent } from '@fabric-app/hooks/useWindowEvent';
import { useMutationDeleteLeaveResources } from '../../../resources/mutations/useMutationDeleteLeaveResources.js';
import { useQueryComments } from '../../../comments/queries/useQueryComments.js';
import dayjs from 'dayjs';
import SubDocumentSearch from '../../../search/components/subDocument/SubDocumentSearch.js';
import { useSubDocumentSearch } from '../../../search/context/SubDocumentSearchContext.js';
import { getWillRegisterSubdocumentSearch } from '../../../search/utils/getWillRegisterSubdocumentSearch.js';
import { ButtonShowSimilar } from '../ButtonShowSimilar.js';
import { AddToLibraryButton } from '../../../spaces/components/AddToLibraryButton.js';
import { appRoutes } from '../../../app/routing/routes.config.js';
import { useAuthStatus } from '@fabric-app/compat';
import { LinkTouch } from '@fabric-app/ui/components/Link/LinkTouch';
import { isDefined } from '@fabric-app/utils/guards';
import { useFeatureGuard_uploadFilesAndCreateResources } from '../../../pricing/hooks/useFeatureGuard.js';
import { ResourceEmailContent } from '../ExpandedResource/Content/Email/ResourceEmailContent.js';

const StyledTagButton = styled(TagButton).withConfig({
  displayName: "ExpandedFdocContent__StyledTagButton",
  componentId: "sc-401cc26b-0"
})([
  `bottom:calc(var(--toolbar-height,0px) + 1rem);display:none;`,
  `{bottom:calc( max(56px + env(safe-area-inset-bottom),var(--keyboard-height)) + var(--toolbar-height,0px) + 1rem );display:flex;}`
], mediaSidebarBottom);
const DesktopTagButton = styled(TagButton).attrs({
  size: "default"
}).withConfig({
  displayName: "ExpandedFdocContent__DesktopTagButton",
  componentId: "sc-401cc26b-1"
})([
  `position:static;box-shadow:none;background:`,
  `;`,
  `{display:none;}`
], cssVar["color-bg-secondary-button"], mediaSidebarBottom);
const ExpandedFdocContent = /* @__PURE__ */ React__default.forwardRef(({ onClose, sidebarRef, rootRef, isEditorFocused, setIsEditorFocused, draftSaveFdoc, draftOnSelectTag, draftTags, isFullscreen, setIsFullscreen, disableGestures, hideBackdrop }, ref) => {
  const { resource, handleDownload, readOnly, isRenameable, disabledActions, userRole } = useResourceDataContextSafe();
  const authStatus = useAuthStatus();
  const { isAvailable: isSubDocumentSearchAvailable, setOpen: setSubDocumentSearchOpen, isOpen: isSubDocumentSearchOpen } = useSubDocumentSearch();
  const willRegisterSubdocumentSearch = useMemo(() => getWillRegisterSubdocumentSearch(resource), [
    resource
  ]);
  const { destinationParent, handleOpenDestinationFolder } = useNewResourceContext();
  const { expandedResourceSidebarOpen } = useExpandedResourceStore((s) => pick(s, [
    "expandedResourceSidebarOpen"
  ]), shallow$1);
  const { isIndexing, showIndicator: showProcessingIndicator } = useResourceLoadingStateIndicatorProps(resource);
  useQueryResourceDetail(resource.id, {
    refetchOnMount: "always",
    enabled: !resource.isDraft
  });
  const { data: user } = useQueryUserInfo();
  const queryResourceTags = useQueryResourceTags(resource.id, {
    enabled: !resource.isDraft
  });
  const [wasEditorChanged, setWasEditorChanged] = useState(false);
  const isNewNotepad = useRef(isResourceDetailNotepad(resource) && dayjs(resource.createdAt).isAfter(dayjs().subtract(3, "seconds")) && resource.permission?.role === PermissionRole.OWNER && resource.modifiedAt === resource.createdAt);
  const [notepadConnectionState, setNotepadConnectionState] = useState("LOADING");
  const onMultiplayerStateChange = useCallback((state) => {
    setNotepadConnectionState(state);
  }, []);
  const onHasPendingChanges = useCallback((hasPendingChanges) => {
    setNeedsSaving(hasPendingChanges);
  }, []);
  const previousFdoc = usePrevious(resource);
  const isLoggedIn = !!user;
  const [contentWrapperRef, setContentWrapperRef] = useState(null);
  const containedImage = useContainedImageSize({
    width: isResourceDetailImage(resource) ? resource.data.attributes?.dimensions?.width || 400 : 0
  });
  const isImage = isResourceDetailImage(resource);
  const isDocumentPDF = isResourceDetailDocumentPDF(resource);
  const isBookmark = isResourceDetailBookmark(resource);
  const isNotepadMetadata = isResourceDetailNotepad(resource);
  const isDocumentPreviewable = useDocumentPreviewable(resource);
  const isDocumentUnpreviewable = useDocumentUnpreviewable(resource);
  const { isDesktopView } = useResponsive();
  const [itemPreviewContentBodyRef, setItemPreviewContentBodyRef] = useState(null);
  const minHeight = useMemo(() => {
    if (isResourceDetailAudio(resource)) return 400;
    if (isResourceDetailDefault(resource) || isDocumentUnpreviewable) return 470;
    return 350;
  }, [
    resource,
    isDocumentUnpreviewable
  ]);
  const paddingOffsetY = useMemo(() => {
    if (isResourceDetailNotepad(resource) || isResourceDetailDefault(resource) || isResourceDetailDocument(resource) || isResourceDetailAudio(resource) || isResourceDetailBookmark(resource) || isResourceDetailHighlight(resource)) return 22;
    return 0;
  }, [
    resource
  ]);
  const [moveable] = useResourceMoveAndResize(isFullscreen, sidebarRef, rootRef, contentWrapperRef, minHeight, expandedResourceSidebarOpen, paddingOffsetY);
  const onClickOnExtraZone = (e) => {
    if (e.target === extraZoneRef) {
      onClose?.();
    }
  };
  const [bodyContext, setBodyContext] = useState({
    scrollPosition: null,
    size: null,
    scrollHeight: 0,
    scrollWidth: 0
  });
  const { setCursor, setNormalizedScrollTop, setNormalizedScrollLeft, others, following } = useSpaceLiveblocksStore((state) => ({
    setCursor: state.setCursor,
    setNormalizedScrollTop: state.setNormalizedScrollTop,
    setNormalizedScrollLeft: state.setNormalizedScrollLeft,
    others: state.liveblocks.others,
    following: state.following
  }), shallow$1);
  useEffect(() => {
    if (!itemPreviewContentBodyRef) return;
    const updateBodyContext = () => {
      setBodyContext((bodyContext2) => ({
        ...bodyContext2,
        scrollPosition: {
          x: itemPreviewContentBodyRef.scrollLeft,
          y: itemPreviewContentBodyRef.scrollTop
        },
        size: {
          width: itemPreviewContentBodyRef.offsetWidth,
          height: itemPreviewContentBodyRef.offsetHeight
        },
        scrollHeight: itemPreviewContentBodyRef.scrollHeight,
        scrollWidth: itemPreviewContentBodyRef.scrollWidth
      }));
      const normalizedScrollTop = itemPreviewContentBodyRef.scrollTop / itemPreviewContentBodyRef.scrollHeight;
      const normalizedScrollLeft = itemPreviewContentBodyRef.scrollLeft / itemPreviewContentBodyRef.scrollWidth;
      setNormalizedScrollTop(normalizedScrollTop);
      setNormalizedScrollLeft(normalizedScrollLeft);
    };
    updateBodyContext();
    const observer = new ResizeObserver(updateBodyContext);
    observer.observe(itemPreviewContentBodyRef);
    const scrollListener = () => {
      updateBodyContext();
    };
    window.addEventListener("scroll", scrollListener);
    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", scrollListener);
    };
  }, [
    itemPreviewContentBodyRef,
    setNormalizedScrollLeft,
    setNormalizedScrollTop
  ]);
  const throttledMouseMove = useRef(0);
  const throttledTimeout = useRef(0);
  const onMouseMoveHandler = useCallback((e) => {
    const { position, size } = moveable;
    if (!position || !size || !itemPreviewContentBodyRef) return;
    clearTimeout(throttledTimeout.current);
    if (Date.now() - throttledMouseMove.current < 80) {
      throttledTimeout.current = window.setTimeout(() => {
        onMouseMoveHandler(e);
      }, 80);
      return;
    }
    const rect = itemPreviewContentBodyRef.getBoundingClientRect();
    const normalizedX = (e.nativeEvent.clientX - rect.left + itemPreviewContentBodyRef.scrollLeft) / itemPreviewContentBodyRef.scrollWidth;
    const normalizedY = (e.nativeEvent.clientY - rect.top + itemPreviewContentBodyRef.scrollTop) / itemPreviewContentBodyRef.scrollHeight;
    setCursor((cursor) => ({
      ...cursor,
      position: {
        x: normalizedX,
        y: normalizedY,
        pressure: null
      }
    }));
    throttledMouseMove.current = Date.now();
  }, [
    moveable,
    itemPreviewContentBodyRef,
    setCursor
  ]);
  const throttledScroll = useRef(0);
  const throttledScrollTimeout = useRef(0);
  const onScroll = useCallback((e) => {
    if (!e.currentTarget) return;
    if (disableGestures) {
      e.preventDefault();
      return;
    }
    const scrollLeft = e.currentTarget?.scrollLeft ?? 0;
    const scrollTop = e.currentTarget?.scrollTop ?? 0;
    clearTimeout(throttledScrollTimeout.current);
    if (Date.now() - throttledScroll.current < 80) {
      throttledScrollTimeout.current = window.setTimeout(() => {
        onScroll(e);
      }, 80);
      return;
    }
    setNormalizedScrollTop(scrollTop / e.currentTarget.scrollHeight);
    setNormalizedScrollLeft(scrollLeft / e.currentTarget.scrollWidth);
    setBodyContext((bodyContext2) => ({
      ...bodyContext2,
      scrollPosition: {
        x: scrollLeft,
        y: scrollTop
      },
      scrollHeight: e.currentTarget?.scrollHeight ?? 0,
      scrollWidth: e.currentTarget?.scrollWidth ?? 0
    }));
    throttledScroll.current = Date.now();
  }, [
    setNormalizedScrollTop,
    setNormalizedScrollLeft,
    disableGestures
  ]);
  useEffect(() => {
    if (!following || !itemPreviewContentBodyRef) return;
    const other = others.find((other2) => other2.id === following);
    if (!other) return;
    const normalizedScrollTop = itemPreviewContentBodyRef.scrollTop / itemPreviewContentBodyRef.scrollHeight;
    const normalizedScrollLeft = itemPreviewContentBodyRef.scrollLeft / itemPreviewContentBodyRef.scrollWidth;
    if (Math.abs(normalizedScrollTop - other.presence.normalizedScrollTop) < 0.01 && Math.abs(normalizedScrollLeft - other.presence.normalizedScrollLeft) < 0.01) return;
    itemPreviewContentBodyRef.scrollTo({
      top: other.presence.normalizedScrollTop * itemPreviewContentBodyRef.scrollHeight,
      left: other.presence.normalizedScrollLeft * itemPreviewContentBodyRef.scrollWidth,
      behavior: "smooth"
    });
    setNormalizedScrollTop(other.presence.normalizedScrollTop);
    setNormalizedScrollLeft(other.presence.normalizedScrollLeft);
  }, [
    following,
    itemPreviewContentBodyRef,
    others,
    setNormalizedScrollTop,
    setNormalizedScrollLeft
  ]);
  const [dynamicContent, setDynamicContent] = useState(() => {
    if (!isResourceDetailNotepad(resource)) {
      return void 0;
    }
    const fdocDataEditorJs = resource.data.preview;
    if (resource.isDraft) {
      if (!fdocDataEditorJs || !("blocks" in fdocDataEditorJs) || !(Array.isArray(fdocDataEditorJs.blocks) && fdocDataEditorJs.blocks.some((b) => isObject(b) && "data" in b && isObject(b.data) && "text" in b.data && isString(b.data.text) && !!b.data.text))) {
        return void 0;
      }
      return {
        ...fdocDataEditorJs,
        time: Date.now() + Math.random()
      };
    }
    return fdocDataEditorJs ?? void 0;
  });
  const dynamicContentRef = useRef(dynamicContent);
  dynamicContentRef.current = dynamicContent;
  const [extraZoneRef, setExtraZoneRef] = useState(null);
  const [topHeaderControlsRef, setTopHeaderControlsRef] = useState(null);
  const [extraDropdownMenuItems, setExtraDropdownMenuItems] = useState([]);
  const fdocContent = isResourceDetailNotepad(resource) ? resource.data.preview : null;
  const fdocContentRef = useRef(fdocContent);
  fdocContentRef.current = fdocContent;
  const [needsSaving, setNeedsSaving] = useState(false);
  const [isSaving, setSaving] = useState(false);
  useOnWindowClose(needsSaving || isSaving);
  const fdocTitle = resource.name || "";
  const { mutate: mutateResourceTitleRename, isPending: isResourceTitleRenamePending } = useMutationResourceTitleRename();
  const _saveTitle = React__default.useCallback((value) => {
    if (resource.isDraft) {
      setNeedsSaving(true);
      return;
    }
    if (value !== fdocTitle) {
      mutateResourceTitleRename({
        resource,
        newTitle: value
      });
    }
  }, [
    resource,
    mutateResourceTitleRename,
    fdocTitle
  ]);
  const saveTitleDebounced = useDebouncedCallback(_saveTitle, 400);
  const titleInput = useInputControls(fdocTitle, {
    onChange: saveTitleDebounced,
    shouldUpdateStateOnDefaultValueChange: () => !isEditorFocused
  });
  const titleInputValueRef = useRef(titleInput.sanitizedValue);
  titleInputValueRef.current = titleInput.sanitizedValue;
  const dynamicYdocRef = useRef(void 0);
  const { track } = useAnalytics();
  const saveDisabled = readOnly || !isLoggedIn || isResourceDetailBookmark(resource) || isResourceDetailHighlight(resource) || isResourceDetailDefault(resource) || isDocumentUnpreviewable || resource.id !== previousFdoc?.id || !!disabledActions.modify;
  const handleDraftSaveFdoc = useCallback(async (title, newContent, newState) => {
    if (!isResourceDetailNotepad(resource) || !resource.isDraft || saveDisabled) {
      return;
    }
    setSaving(true);
    const newEditorJsContent = dynamicContentRef.current || void 0;
    const newId = await draftSaveFdoc?.({
      name: title,
      content: !!newContent && "content" in newContent ? newContent.content : "",
      state: newState
    });
    fdocContentRef.current = newEditorJsContent ?? null;
    setNeedsSaving(false);
    setSaving(false);
    return newId;
  }, [
    resource,
    draftSaveFdoc,
    saveDisabled
  ]);
  const { mutate: mutateNotepadState, isPending: isNotepadStatePending } = useMutationNotepadStateUpdate({
    resourceId: resource.id
  });
  const updateFdocTitleAndContent = useCallback(async () => {
    if (saveDisabled || !!disabledActions.modify) {
      return;
    }
    const newEditorJsContent = dynamicContentRef.current || void 0;
    const isTitleSame = titleInputValueRef.current === resource.name || !resource.isDraft;
    const isContentSame = (newEditorJsContent?.content === fdocContentRef.current?.content || !resource.isDraft) && !dynamicYdocRef.current;
    if (isContentSame && isTitleSame) {
      setNeedsSaving(false);
      return;
    }
    setSaving(true);
    if (isResourceDetailNotepad(resource)) {
      if (resource.isDraft) {
        const title = titleInputValueRef.current;
        const newState = dynamicYdocRef.current ? Y.encodeStateAsUpdate(dynamicYdocRef.current) : void 0;
        dynamicYdocRef.current = void 0;
        dynamicContentRef.current = void 0;
        await handleDraftSaveFdoc(title, newEditorJsContent, newState);
        fdocContentRef.current = newEditorJsContent ?? null;
        setNeedsSaving(false);
        setSaving(false);
        return;
      }
      if (dynamicYdocRef.current) {
        mutateNotepadState({
          resource,
          update: Y.encodeStateAsUpdate(dynamicYdocRef.current),
          optimisticContent: {
            content: newEditorJsContent?.content || ""
          }
        }, {
          onSettled: () => {
            setNeedsSaving(false);
            setSaving(false);
          }
        });
        fdocContentRef.current = newEditorJsContent ?? null;
        dynamicYdocRef.current = void 0;
      }
    } else {
      setNeedsSaving(false);
      setSaving(false);
    }
  }, [
    saveDisabled,
    disabledActions.modify,
    resource,
    handleDraftSaveFdoc,
    mutateNotepadState
  ]);
  const debouncedSave = useDebouncedCallback(updateFdocTitleAndContent, 1e4);
  const saveChangesRef = useRef(debouncedSave);
  saveChangesRef.current = debouncedSave;
  const optimisticNotepadStateUpdate = useOptimisticNotepadStateUpdate();
  const throttledTrackNotepadEdit = useThrottledCallback(() => {
    track(AnalyticsEvents.NotepadEdit);
  }, 1e3);
  const notepadContentRef = useRef(void 0);
  const onEditorChange = useCallback((data, ydoc) => {
    setEditorMarkdown(data.blocks.map((block) => block.data.text).join("\n"));
    setWasEditorChanged(true);
    if (resource.isDraft) {
      setNeedsSaving(true);
      setDynamicContent(data);
      dynamicContentRef.current = data;
      dynamicYdocRef.current = ydoc;
      saveChangesRef.current();
      throttledTrackNotepadEdit.current();
      return;
    }
    throttledTrackNotepadEdit.current();
    notepadContentRef.current = data;
  }, [
    resource.isDraft,
    throttledTrackNotepadEdit,
    setWasEditorChanged
  ]);
  const onOfflineChange = useCallback((update, hashes, docChanged, inMultiplayer) => {
    if (!isResourceDetailNotepad(resource) || resource.isDraft) return;
    const changes = {
      resource,
      update,
      docChanged,
      optimisticContent: {
        content: notepadContentRef.current?.content || ""
      }
    };
    setWasEditorChanged(true);
    if (inMultiplayer) {
      optimisticNotepadStateUpdate(changes);
      return;
    }
    mutateNotepadState(changes, {
      onSuccess: () => {
        setNeedsSaving(false);
        setSaving(false);
        NotepadUpdateFailsafeService.getInstance().markAsSentByHash(resource.id, hashes);
      }
    });
  }, [
    resource,
    mutateNotepadState,
    optimisticNotepadStateUpdate
  ]);
  const refDraftCreate = useRef(void 0);
  const mutationCreateNotepadResource = useMutationCreateNotepadResource();
  const handleUploadNotepadFile = useCallback(async (options) => {
    let notepadId = resource.id;
    if (refDraftCreate.current) {
      notepadId = await refDraftCreate.current;
    } else {
      if (resource.isDraft) {
        refDraftCreate.current = handleDraftSaveFdoc(titleInputValueRef.current, dynamicContentRef.current);
        notepadId = await refDraftCreate.current;
      }
    }
    if (!notepadId) {
      return null;
    }
    const uploadId = v4();
    useExpandedResourceStore.getState().expandedResourcePendingUploads.add(uploadId);
    const removeFromPending = () => {
      useExpandedResourceStore.getState().expandedResourcePendingUploads.delete(uploadId);
    };
    const createdResource = await mutationCreateNotepadResource.mutateAsync({
      targetResourceId: notepadId,
      ...options
    }, {
      onError: removeFromPending
    });
    if (createdResource) {
      return {
        resource: createdResource,
        ackProcessed: removeFromPending
      };
    }
    removeFromPending();
    return null;
  }, [
    resource,
    handleDraftSaveFdoc,
    titleInputValueRef,
    dynamicContentRef,
    refDraftCreate,
    mutationCreateNotepadResource
  ]);
  const leaveOrDelete = useDeleteOrLeaveResource({
    onConfirmDelete: onClose,
    onConfirmLeave: onClose
  });
  const { data: comments } = useQueryComments(resource.id);
  const { mutate: mutateDeleteLeaveResources } = useMutationDeleteLeaveResources();
  const notepadConnectionStateRef = useRef(notepadConnectionState);
  notepadConnectionStateRef.current = notepadConnectionState;
  const wasEditorChangedRef = useRef(wasEditorChanged);
  wasEditorChangedRef.current = resource.permission?.role === PermissionRole.OWNER && (wasEditorChanged || resource.modifiedAt !== resource.createdAt || (comments?.length ?? 0) > 0 || (queryResourceTags.data?.length ?? 0) > 0);
  useUnmount(() => {
    if (isNewNotepad.current && !wasEditorChangedRef.current) {
      mutateDeleteLeaveResources({
        resourceIds: [
          resource.id
        ],
        noToast: true
      });
      return;
    }
    updateFdocTitleAndContent();
    if ("cancel" in saveChangesRef.current) {
      saveChangesRef.current.cancel();
    }
  }, {
    avoidStrictMode: true
  });
  useWindowEvent("beforeunload", () => {
    if (isNewNotepad.current && !wasEditorChangedRef.current) {
      mutateDeleteLeaveResources({
        resourceIds: [
          resource.id
        ],
        noToast: true
      });
      return;
    }
  });
  const handleCopySourceURL = () => {
    if (resource.originUrl) {
      navigator.clipboard.writeText(resource.originUrl);
    }
  };
  const providerValue = useMemo(() => ({
    itemPreviewContentBodyRef,
    topHeaderControlsRef,
    extraZoneRef,
    extraDropdownMenuItems,
    setExtraDropdownMenuItems,
    isFullscreen,
    onClose
  }), [
    itemPreviewContentBodyRef,
    topHeaderControlsRef,
    extraZoneRef,
    extraDropdownMenuItems,
    setExtraDropdownMenuItems,
    isFullscreen,
    onClose
  ]);
  const { isMobileView } = useResponsive();
  const [headerRef, setHeaderRef] = useState(null);
  const [closing, setClosing] = useState(false);
  const { offsetY } = useSwipe(headerRef, {
    onSwipeDown: () => {
      if (!onClose) return;
      setClosing(true);
      setTimeout(() => {
        onClose?.();
      }, 50);
    }
  }, {
    sensitivity: 150,
    sensitivityPreventPropagation: 150,
    disabled: !isMobileView || !onClose || disableGestures
  });
  const [tinyPagesIsVisible, setTinyPagesIsVisible] = useState(true);
  const toggleFullscreen = useCallback(() => {
    setIsFullscreen((isFullscreen2) => !isFullscreen2);
  }, [
    setIsFullscreen
  ]);
  const [editTagsModalOpen, setEditTagsModalOpen] = useState(false);
  const mutationResourcesTagAssign = useMutationResourcesTagAssign();
  const { mutate: mutateMoveResourcesById } = useMutationMoveResourcesById();
  const { onSelectSuggestion: onSelectSuggestionDraft } = useNewResourceContext();
  const [editorMarkdown, setEditorMarkdown] = useState(null);
  const inlineSuggestionsEnabled = resource.isDraft || resource.draftId;
  const suggestionsContext = (
    // We make sure the fdoc is either a draft OR has a draft id (just created)
    (!!titleInput.value || !!editorMarkdown || !resource.isDraft) && (inlineSuggestionsEnabled || editTagsModalOpen) ? resource.isDraft ? {
      name: titleInput.value ?? void 0,
      otherInfo: prettifyForLLM({
        notepadContent: editorMarkdown
      })
    } : {
      resourceId: resource.id
    } : void 0
  );
  const onEditorInitialized = useCallback((value) => {
    if (resource.isDraft) return;
    setEditorMarkdown(value.blocks.map((block) => block.data.text).join("\n"));
  }, [
    resource.isDraft,
    setEditorMarkdown
  ]);
  const { mutateAsync: mutateTagCreate } = useMutationTagCreate();
  const onSelectTag = useCallback((tag, selected) => {
    if (!resource || resource.isDraft) {
      draftOnSelectTag?.(tag, selected);
      return;
    }
    mutationResourcesTagAssign.mutate({
      tag,
      resourceIds: [
        resource.id
      ],
      operation: selected ? "assign" : "unassign"
    });
  }, [
    mutationResourcesTagAssign,
    resource,
    draftOnSelectTag
  ]);
  const onSelectSuggestion = useCallback(async (suggestion) => {
    if (resource.isDraft || draftOnSelectTag) return onSelectSuggestionDraft(suggestion);
    if (suggestion.type === SuggestionItemType.TAG && suggestion.tag) {
      onSelectTag(suggestion.tag.isDraft ? await mutateTagCreate({
        tagName: suggestion.name,
        action: "suggestion"
      }) : suggestion.tag, true);
    } else if (suggestion.type === SuggestionItemType.FOLDER && suggestion.id) mutateMoveResourcesById({
      newParent: {
        id: suggestion.id,
        name: suggestion.name
      },
      resourceIds: [
        resource.id
      ]
    });
  }, [
    draftOnSelectTag,
    mutateMoveResourcesById,
    mutateTagCreate,
    onSelectSuggestionDraft,
    onSelectTag,
    resource.id,
    resource.isDraft
  ]);
  const { newModalOptions } = useModalNewResourceContext();
  const pastedContent = resource.isDraft && isResourceDetailNotepad(resource) ? newModalOptions.dataTransfer ?? newModalOptions.text : void 0;
  const isTitleEditable = isRenameable && !disabledActions.modify;
  const handleOpenAssetsPanel = useHandleOpenAssetsPanel();
  const queryAssets = useQueryResourceAssets({
    resource
  });
  const setShareModalOpen = () => resourceSharingModal.open({
    resourceId: resource.id
  });
  const isNotepadLoading = isSaving || isNotepadStatePending || notepadConnectionState === "CONNECTING" || isResourceTitleRenamePending;
  const notepadAutoFocus = useMemo(() => resource.isDraft || dayjs(resource.createdAt).isAfter(Date.now() - 1e4), [
    resource.isDraft,
    resource.createdAt
  ]);
  const featureGuardUploadFilesAndCreateResources = useFeatureGuard_uploadFilesAndCreateResources();
  const onCheckBeforeUpload = useCallback(({ files }) => {
    const res = featureGuardUploadFilesAndCreateResources.check(files, {
      showUpsellBannerOnNotAllowed: true
    }).isAllowed ? "CONTINUE" : "ABORT";
    return res;
  }, [
    featureGuardUploadFilesAndCreateResources
  ]);
  const notepadBottomElement = useMemo(() => resource.isDraft ? /* @__PURE__ */ jsxs(Flex, {
    direction: "column",
    gap: "sectionsShort",
    style: {
      padding: "13px 8px"
    },
    children: [
      resource.isDraft && /* @__PURE__ */ jsx(CustomDestinationButton, {
        destinationParent,
        handleOpenDestinationFolder
      }),
      /* @__PURE__ */ jsx(MagicSuggestions, {
        disabled: !inlineSuggestionsEnabled
      })
    ]
  }) : /* @__PURE__ */ jsx(MagicSuggestions, {
    style: {
      padding: "13px 8px"
    },
    disabled: !inlineSuggestionsEnabled
  }), []);
  const notepadOnEditorCreate = useCallback((editor) => {
    editor.commands.defineResourceId(resource.id);
  }, []);
  const notepadOnTitleChange = useCallback((title) => {
    if (!isDefined(title)) return;
    titleInput.onChange(title);
  }, []);
  const shareToken = useContextShareToken();
  const accessToken = shareToken?.accessToken;
  const isPublished = shareToken?.type === "publishing";
  const { disabledDownload } = useContextShareTokenExtraPermissions();
  return /* @__PURE__ */ jsx(MagicSuggestionsContextProvider, {
    onSelectSuggestion,
    context: suggestionsContext,
    includeFolders: Boolean(resource.isDraft || resource.draftId),
    children: /* @__PURE__ */ jsxs(ExpandedFdocContentContext.Provider, {
      value: providerValue,
      children: [
        /* @__PURE__ */ jsx(EditTagsModal, {
          onSelect: onSelectTag,
          selectedTags: draftTags ?? queryResourceTags.data ?? [],
          open: editTagsModalOpen,
          onOpenChange: setEditTagsModalOpen,
          selectedResourcesCount: 1
        }),
        !!queryAssets.data?.count && /* @__PURE__ */ jsx(AssetsPanel, {
          resource,
          isFullscreen
        }, `${resource.id}-notepad-assets-panel`),
        /* @__PURE__ */ jsxs(ExpandedFdocElements.ContentWrapper, {
          "data-testid": "expanded-fdoc-main-content",
          "data-content-no-preview": isResourceDetailDefault(resource) || isDocumentUnpreviewable,
          "data-content-audio": isResourceDetailAudio(resource),
          "data-content-image": isImage,
          "data-content-image-loading": isImage && containedImage.loaded,
          "data-content-bookmark": isResourceDetailBookmark(resource),
          "data-content-notepad": isNotepadMetadata || isDocumentPreviewable,
          "data-fullscreen": isFullscreen && isDesktopView,
          "data-no-gestures": disableGestures,
          style: moveable.moved ? {
            maxWidth: "none",
            maxHeight: "none",
            width: "auto",
            height: "auto",
            position: "fixed",
            left: moveable.position?.x ?? 0,
            top: moveable.position?.y ?? 0,
            padding: 0
          } : {},
          children: [
            /* @__PURE__ */ jsx(ExpandedFdocElements.Closer, {
              onClick: onClose
            }),
            /* @__PURE__ */ jsx("div", {
              ref: setExtraZoneRef,
              onClick: onClickOnExtraZone
            }),
            /* @__PURE__ */ jsx(ExpandedFdocElements.ContentMain, {
              "data-content-bookmark": isBookmark,
              "data-content-no-preview": isResourceDetailDefault(resource) || isDocumentUnpreviewable,
              "data-content-image": isImage,
              "data-content-image-loading": isImage && containedImage.loaded,
              "data-content-pdf": isDocumentPDF,
              style: {
                ...moveable.moved ? {
                  width: moveable.size?.width ?? void 0,
                  height: moveable.size?.height ?? void 0,
                  padding: 0,
                  maxWidth: "none",
                  maxHeight: "none"
                } : {
                  maxWidth: isImage && containedImage.imgWidth && !isFullscreen ? Math.max(containedImage.imgWidth, MIN_WIDTH) : void 0,
                  maxHeight: isImage ? "100%" : void 0
                },
                ...{
                  "--offset-y": isMobileView && !closing ? `${offsetY}px` : void 0
                }
              },
              ref: setContentWrapperRef,
              children: /* @__PURE__ */ jsxs(ExpandedFdocElements.ItemPreviewContent, {
                style: hideBackdrop ? {
                  border: `1px solid ${cssVar["color-border-primary"]}`
                } : void 0,
                children: [
                  !resource.isHidden && /* @__PURE__ */ jsx(StyledTagButton, {
                    selectedTags: draftTags ?? queryResourceTags.data ?? [],
                    onClick: () => setEditTagsModalOpen(true)
                  }),
                  moveable.resizeUiHandlers,
                  /* @__PURE__ */ jsxs(ExpandedFdocElements.ItemPreviewContentBody, {
                    style: isFullscreen ? {
                      borderBottomLeftRadius: "0px"
                    } : {},
                    children: [
                      /* @__PURE__ */ jsxs(ExpandedFdocElements.ItemPreviewContentHeader, {
                        "data-movable-area": "true",
                        "data-content-no-preview": isResourceDetailDefault(resource) || isDocumentUnpreviewable,
                        "data-testid": "item-preview-content-header",
                        onMouseDown: moveable.onPositionMouseDown,
                        isMoving: moveable.isMoving,
                        ref: setHeaderRef,
                        children: [
                          /* @__PURE__ */ jsxs(Flex, {
                            alignItems: "center",
                            overflow: "hidden",
                            gap: "element",
                            children: [
                              isFullscreen && accessToken && /* @__PURE__ */ jsx(ButtonIcon, {
                                size: "default",
                                variant: "bg-secondary",
                                as: LinkTouch,
                                href: authStatus === "authenticated" ? appRoutes.home : appRoutes.auth.signin,
                                children: /* @__PURE__ */ jsx(IconSidebar24HomeIcon, {})
                              }),
                              isFullscreen && /* @__PURE__ */ jsx(AddToLibraryButton, {
                                type: "resource",
                                resource
                              }),
                              isFullscreen && /* @__PURE__ */ jsx(ButtonPreviousResourceFullscreen, {}),
                              isFullscreen && isDocumentPDF && /* @__PURE__ */ jsx(ButtonIcon, {
                                onClick: () => setTinyPagesIsVisible((prev) => !prev),
                                variant: "bg-secondary",
                                size: "default",
                                children: /* @__PURE__ */ jsx(MenuIcon, {})
                              }),
                              showProcessingIndicator && !(isResourceDetailNotepad(resource) && !!resource.isDraft) && /* @__PURE__ */ jsx(Tooltip, {
                                label: "Waiting to be indexed and analyzed by AI",
                                children: /* @__PURE__ */ jsx(StateSpinner, {
                                  size: 22,
                                  thickness: 3,
                                  isIndexing
                                })
                              }),
                              /* @__PURE__ */ jsx(ResourceTitleEditable, {
                                titleInput,
                                setIsEditorFocused,
                                user: user ?? null,
                                onSubmit: saveTitleDebounced,
                                readOnly: !isTitleEditable,
                                resourceUrl: resource.originUrl
                              }),
                              !resource.isDraft && userRole !== PermissionRole.OWNER && !isPublished && /* @__PURE__ */ jsx(StyledBadgePermissionRole, {
                                role: userRole,
                                itemType: "resource"
                              })
                            ]
                          }),
                          /* @__PURE__ */ jsxs(ExpandedFdocElements.ContentHeaderControls, {
                            children: [
                              /* @__PURE__ */ jsx(ExpandedFdocElements.TopHeaderControlsExtra, {
                                ref: setTopHeaderControlsRef
                              }),
                              isFullscreen && !resource.isDraft && !isResourceIntegrationItem(resource) && /* @__PURE__ */ jsxs(Fragment, {
                                children: [
                                  !accessToken && /* @__PURE__ */ jsx(ButtonShowSimilar, {
                                    resource,
                                    onClick: onClose
                                  }),
                                  isPublished ? null : /* @__PURE__ */ jsx(MemberBarResourcerWithLiveBlocks, {
                                    resourceId: resource.id,
                                    isPublicShared: resource.isShared || false,
                                    renderShareButtonOutside: true,
                                    onOpenShareModal: disabledActions.manageSomePermissionRoles ? void 0 : setShareModalOpen
                                  })
                                ]
                              }),
                              (isResourceDetailNotepad(resource) || isDocumentPreviewable) && !isPublished && isDesktopView && /* @__PURE__ */ jsx(Modal.IconButton, {
                                onClick: toggleFullscreen,
                                "data-testid": "fullscreen-preview-button",
                                tabIndex: 4,
                                children: isFullscreen ? /* @__PURE__ */ jsx(ExitFullscreenIcon, {
                                  style: {
                                    width: 20,
                                    height: 20
                                  }
                                }) : /* @__PURE__ */ jsx(FullscreenIcon, {})
                              }),
                              (willRegisterSubdocumentSearch || isSubDocumentSearchAvailable) && /* @__PURE__ */ jsx(Modal.IconButton, {
                                active: isSubDocumentSearchOpen,
                                onClick: () => setSubDocumentSearchOpen(!isSubDocumentSearchOpen),
                                children: /* @__PURE__ */ jsx(IconNavigational24Search, {})
                              }),
                              resource.originUrl && /* @__PURE__ */ jsx(Modal.IconButton, {
                                as: LinkExternal,
                                href: resource.originUrl,
                                children: /* @__PURE__ */ jsx(IconLinkArrow, {
                                  style: {
                                    width: 14
                                  }
                                })
                              }),
                              !resource.isHidden && /* @__PURE__ */ jsx(DesktopTagButton, {
                                selectedTags: draftTags ?? queryResourceTags.data ?? [],
                                onClick: () => setEditTagsModalOpen(true)
                              }),
                              isDocumentPreviewable && handleDownload && !disabledDownload && /* @__PURE__ */ jsx(ButtonIconDownload, {
                                onClick: handleDownload,
                                tabIndex: 4
                              }),
                              !accessToken && !resource.isDraft && /* @__PURE__ */ jsxs(DropdownMenu.Base, {
                                renderTriggerElement: ({ onOpenChange }) => /* @__PURE__ */ jsx(DropdownMenu.TriggerButtonThreeDots, {
                                  onOpenChange,
                                  tabIndex: 4
                                }),
                                children: [
                                  extraDropdownMenuItems.length > 0 && /* @__PURE__ */ jsx(DropdownMenu.Group, {
                                    children: extraDropdownMenuItems.map((item) => item.type === "item" ? /* @__PURE__ */ jsx(DropdownMenu.Item, {
                                      onSelect: item.onSelect,
                                      children: item.children
                                    }, item.key) : /* @__PURE__ */ jsx(DropdownMenu.Separator, {}, item.key))
                                  }),
                                  /* @__PURE__ */ jsxs(DropdownMenu.Group, {
                                    children: [
                                      !accessToken && resource.originUrl && /* @__PURE__ */ jsx(DropdownMenu.Item, {
                                        onSelect: handleCopySourceURL,
                                        "data-testid": "fdoc-copy-source-url-button",
                                        children: "Copy original URL"
                                      }),
                                      !accessToken && !resource.isHidden && /* @__PURE__ */ jsx(DropdownMenu.Item, {
                                        onSelect: () => setEditTagsModalOpen(true),
                                        children: "Add/edit tags"
                                      }),
                                      /* @__PURE__ */ jsx(DropdownMenu.Item, {
                                        onSelect: () => {
                                          resourceMoveModal.open({
                                            resources: [
                                              resource
                                            ]
                                          });
                                        },
                                        "data-testid": "fdoc-add-to-space-button",
                                        disabled: !!disabledActions.move,
                                        disabledReason: disabledActions.move,
                                        children: "Move..."
                                      }),
                                      /* @__PURE__ */ jsx(DropdownMenu.Item, {
                                        onSelect: setShareModalOpen,
                                        disabled: !!disabledActions.manageSomePermissionRoles,
                                        disabledReason: disabledActions.manageSomePermissionRoles,
                                        children: resource?.isDirectShared ? "Manage sharing" : "Share"
                                      }),
                                      /* @__PURE__ */ jsx(DropdownItemResourceUserPinHome, {}),
                                      /* @__PURE__ */ jsx(DropdownItemResourceRefreshBookmark, {}),
                                      queryAssets.data?.count ? /* @__PURE__ */ jsx(DropdownMenu.Item, {
                                        onSelect: () => handleOpenAssetsPanel(true),
                                        children: "Show all embedded sub-items"
                                      }) : null,
                                      /* @__PURE__ */ jsx(DropdownMenu.Item, {
                                        onSelect: leaveOrDelete.action,
                                        "data-testid": "fdoc-delete-button",
                                        tabIndex: 5,
                                        disabled: !!leaveOrDelete.disabledReason,
                                        disabledReason: leaveOrDelete.disabledReason,
                                        variant: "danger",
                                        children: "Delete"
                                      })
                                    ]
                                  })
                                ]
                              }),
                              onClose && /* @__PURE__ */ jsx(Modal.Close, {
                                // changed from onClick the modal now has onOpenChange so closing is handled there
                                // onTouchEnd is necessary, HOTFIX, on mobile (ios app, safari) the onClick is not being triggered
                                onPointerUp: onClose,
                                "data-testid": "close-preview-button",
                                tabIndex: 4
                              })
                            ]
                          })
                        ]
                      }),
                      /* @__PURE__ */ jsx(Flex, {
                        ref,
                        flexGrow: true,
                        style: {
                          overflow: "hidden"
                        },
                        children: /* @__PURE__ */ jsxs(Flex, {
                          direction: "column",
                          flexGrow: true,
                          style: {
                            maxWidth: "100%",
                            width: "1px"
                          },
                          children: [
                            /* @__PURE__ */ jsxs(ExpandedFdocElements.ItemPreviewContentBody, {
                              className: "dashboard_scrollbar",
                              onMouseMove: onMouseMoveHandler,
                              onScroll,
                              ref: setItemPreviewContentBodyRef,
                              children: [
                                /* @__PURE__ */ jsx(SubDocumentSearch, {}),
                                /* @__PURE__ */ jsx(SpaceCursors, {
                                  bodyContext,
                                  resourceId: resource.id
                                }),
                                isResourceDetailHighlight(resource) && /* @__PURE__ */ jsx(ResourceHighlightText, {}),
                                isResourceDetailNotepad(resource) && /* @__PURE__ */ jsx(MultiplayerEditor, {
                                  onOfflineChange,
                                  onMultiplayerStateChange,
                                  onHasPendingChanges,
                                  tiptapProps: {
                                    editable: isLoggedIn && !disabledActions.modify,
                                    initialValue: dynamicContent,
                                    onChange: onEditorChange,
                                    onInitialize: onEditorInitialized,
                                    onEditorFocusChange: setIsEditorFocused,
                                    onUpload: handleUploadNotepadFile,
                                    onCheckBeforeUpload,
                                    tabIndex: "10",
                                    /**
                                    * autofocus if item is not older than 10s - notepads are now created against api without drafting
                                    */
                                    autoFocus: notepadAutoFocus,
                                    pastedContent,
                                    contentClassName: "tiptap_editor",
                                    bottomElement: notepadBottomElement,
                                    onCreate: notepadOnEditorCreate,
                                    title: titleInput.value,
                                    onTitleChange: notepadOnTitleChange,
                                    isLoading: isNotepadLoading
                                  }
                                }, resource.draftId || resource.id),
                                resource.fileUrl && /* @__PURE__ */ jsx(StoredFileContent, {
                                  imageRef: containedImage.imageRef,
                                  isFullscreenEnabled: isFullscreen,
                                  tinyPagesIsVisible,
                                  disableGestures
                                }),
                                isResourceDetailBookmark(resource) && /* @__PURE__ */ jsx(PageResource, {}),
                                isResourceDetailEmail(resource) && /* @__PURE__ */ jsx(ResourceEmailContent, {})
                              ]
                            }),
                            resource.root?.subtype === "NOTION" && /* @__PURE__ */ jsx(NotionFooter, {
                              resource
                            })
                          ]
                        })
                      })
                    ]
                  })
                ]
              })
            })
          ]
        })
      ]
    })
  });
});
ExpandedFdocContent.displayName = "ExpandedFdocContent";
const CustomDestinationButton = styled(DestinationButton).withConfig({
  displayName: "ExpandedFdocContent__CustomDestinationButton",
  componentId: "sc-401cc26b-2"
})([
  `position:static;bottom:unset;left:unset;transform:unset;align-self:center;color:white;transition:0.2s all;`
]);
const StyledBadgePermissionRole = styled(BadgePermissionRole).withConfig({
  displayName: "ExpandedFdocContent__StyledBadgePermissionRole",
  componentId: "sc-401cc26b-3"
})([
  `&:first-child{margin-left:1.125rem;}`
]);
const ButtonPreviousResourceFullscreen = () => {
  const showPreviousResource = useShowPreviousExpandedResource();
  if (showPreviousResource) {
    return /* @__PURE__ */ jsx(Button, {
      shape: "square",
      variant: "transparent",
      onClick: showPreviousResource,
      children: /* @__PURE__ */ jsx(IconArrow, {
        style: {
          fontSize: "1.35rem"
        }
      })
    });
  }
  return null;
};

export { ExpandedFdocContent as default };
//# sourceMappingURL=ExpandedFdocContent.js.map
